// Use this for Local Development
// export const WEBSITE_URL = "http://127.0.0.1:8000";
// export const WEBSITE_URL = "https://app.dittomart.in";
//   export const WEBSITE_URL = "https://dev.dittomart.in";
export const WEBSITE_URL = "https://app.dittomart.in";
// export const WEBSITE_URL = "http://192.168.0.6:8001";

// Comment out the above and Uncomment the below line before building the files for Production
// export const WEBSITE_URL = "https://" + window.location.hostname;

export const currentDomain = window.location.host; // fixme: use this in production
// export const currentDomain = 'app.thedelightscafe.com'; //fixme: comment this in production
